/**
 * Status Service for API integration
 */
import apiService from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

class StatusService {
  /**
   * Fetch available user statuses from dropdowns API
   * @returns {Promise<Array>} Array of status objects
   */
  // async getStatuses() {
  //   try {
  //     const res = await apiService.getAll('api/v1/dropdowns');
  //     const statuses =
  //       res?.data?.userStatuses ||
  //       res?.userStatuses ||
  //       [];

  //     return statuses.map(s => ({
  //       value: s.value,
  //       label: s.label
  //     }));
  //   } catch (error) {
  //     console.warn('Using fallback statuses:', error.message);
  //     return [
  //       { value: 'ACTIVE', label: 'Active' },
  //       { value: 'INACTIVE', label: 'Inactive' },
  //       { value: 'SUSPENDED', label: 'Suspended' },
  //       { value: 'DELETED', label: 'Deleted' },
  //     ];
  //   }
  // }

  /**
   * Create a new status
   * @param {Object} status - Status object to create
   * @returns {Promise<Object>} Created status
   */
  async createStatus(status) {
    try {
      const response = await fetch(`${API_BASE_URL}/statuses`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(status),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error creating status:', error);
      throw error;
    }
  }

  /**
   * Update an existing status
   * @param {string} id - Status ID
   * @param {Object} updates - Updates to apply
   * @returns {Promise<Object>} Updated status
   */
  async updateStatus(id, updates) {
    try {
      const response = await fetch(`${API_BASE_URL}/statuses/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error updating status:', error);
      throw error;
    }
  }

  /**
   * Delete a status
   * @param {string} id - Status ID
   * @returns {Promise<boolean>} Success status
   */
  async deleteStatus(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/statuses/${id}`, {
        method: 'DELETE',
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return true;
    } catch (error) {
      console.error('Error deleting status:', error);
      throw error;
    }
  }
}

export default new StatusService();